<template>
  <div v-if="showNotice" class="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 z-50">
    <div class="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
      <p class="text-sm text-gray-600">
        {{ currentLanguage === 'en' 
          ? 'We use cookies to enhance your browsing experience. By continuing to use our website, you agree to our use of cookies.' 
          : 'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία περιήγησής σας. Συνεχίζοντας να χρησιμοποιείτε τον ιστότοπό μας, συμφωνείτε με τη χρήση των cookies.' }}
      </p>
      <div class="flex gap-4">
        <router-link 
          to="/privacy-policy" 
          class="text-sm text-[#233862] hover:text-[#3D5A98]"
        >
          {{ currentLanguage === 'en' ? 'Privacy Policy' : 'Πολιτική Απορρήτου' }}
        </router-link>
        <button
          @click="acceptCookies"
          class="bg-[#FF5F00] text-white px-4 py-2 rounded text-sm hover:bg-[#FF7A00] transition-colors"
        >
          {{ currentLanguage === 'en' ? 'Accept' : 'Αποδοχή' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useLanguage } from '@/composables/useLanguage'

const { currentLanguage } = useLanguage()
const showNotice = ref(false)

const acceptCookies = () => {
  localStorage.setItem('cookiesAccepted', 'true')
  showNotice.value = false
}

onMounted(() => {
  // Check if user has already accepted cookies
  const cookiesAccepted = localStorage.getItem('cookiesAccepted')
  if (!cookiesAccepted) {
    showNotice.value = true
  }
})
</script>
